module.exports = __webpack_public_path__ + "img/7x2.2edb9506.png";